<template>
  <div :class="$style['pt-sub-title']">
      <div :class="$style['sub-title-content']">
          <div :class="$style['sub-title-text']">{{title}}
            <slot :class="$style['sub-title-tip-text']" name="line"></slot>
          </div>
           <slot/>
      </div>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-sub-title'

export default {
  name: 'pt-sub-title',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-sub-title{
    width: 100%;
    margin: 15px 0;
}
.sub-title-content{
    padding: 10px 20px;
    display:flex;
    justify-content:space-between;
    background-color: #F9F9F9;
}
.sub-title-text{
    font-size: 16px;
}
.sub-title-tip-text{
    margin-left: 20px;
    font-size: 13px;
}
</style>
